import { Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ThemeProvider } from './context/ThemeContext';
import ConsentPage from './pages/ConsentPage';
import LoginPage from './pages/LoginPage';
import ErrorPage from './pages/ErrorPage';

export default function App() {
  return (
    <ThemeProvider>
      <Toaster position='top-center' />
      <Routes>
        <Route path='/consent' element={<ConsentPage />} />
        <Route path='/login' element={<LoginPage />} />
        <Route path='*' element={<ErrorPage />} />
      </Routes>
    </ThemeProvider>
  );
}
